import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import makeAndHandleRequest from './util/makeAndHandleRequest';

/* example-start */
class Search extends Component {
	
	constructor(props) {
    super(props);
		
		this.state = {
			allowNew: false,
			isLoading: false,
			multiple: false,
			options: [],
			selected: [],
			submit: false,
		};
  }
	
  handleSearch = (query) => {
    this.setState({
			isLoading: true,
			submit: false,
		});
    makeAndHandleRequest(query)
      .then(({options}) => {
				this.setState({
					isLoading: true,
					options})
      });
  }
	
	handleSearchChange = (selected) => {
		this.props.onSearchChange(selected);
		this.setState({
			submit: true,
		})
	}
	
  render() {

    return (
		<div className='search-box'>
			<AsyncTypeahead
				{...this.state}
				labelKey='full_address'
				ignoreDiacritics={true}
				minLength={3}
				onSearch={this.handleSearch}
				placeholder='Search by address for block details'
				onChange={this.handleSearchChange}
			/>
			{this.state.submit === true && <Redirect to="/"/>}			
		</div>
    );
  }
}

export default Search;


// WEBPACK FOOTER //
// ./src/Searchbar.js


// WEBPACK FOOTER //
// ./src/Searchbar.js